import { render } from "./AddVehicleSharing.vue?vue&type=template&id=3a007c5f"
import script from "./AddVehicleSharing.vue?vue&type=script&lang=js"
export * from "./AddVehicleSharing.vue?vue&type=script&lang=js"
script.render = render

export default script